import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

interface WelcomeProps {
  userName: string;
}

export const WelcomeCard: React.FC<WelcomeProps> = ({ userName }) => {
  const linkStyles = "text-brand-blue hover:text-brand-black";

  return (
    <div className='flex flex-col justify-center'>
      <div className='flex justify-center w-full h-full'>
        <div className='text-6xl'>
          <span className='text-6xl' role='img' aria-label='Waving Hand Sign'>
            👋
          </span>
        </div>
        <div className='text-6xl'>
          <h2 className='text-6xl'>
            <FormattedMessage
              id='Main.Welcome'
              values={{ user: userName }}
              defaultMessage='Welcome {user}'
            />
          </h2>
        </div>
      </div>
      <div className='text-4xl text-center mt-8'>
        <p className={linkStyles}>
          <Link to='/createevent'>
            <FormattedMessage id='Navigation.CreateEvent' />
          </Link>
          <span className='text-4xl' role='img' aria-label='Party Popper'>
            🎉
          </span>
        </p>
        <p className={linkStyles}>
          <Link to='/events'>
            <FormattedMessage id='Navigation.ListEvents' />
          </Link>
          <span className='text-4xl' role='img' aria-label='Package'>
            📦
          </span>
        </p>
        <p className={linkStyles}>
          <Link to='/createcert'>
            <FormattedMessage id='Navigation.Cert_New' />
          </Link>
          <span className='text-4xl' role='img' aria-label='Graduation Cap'>
            🎓
          </span>
        </p>
        <p className={linkStyles}>
          <Link to='/certs'>
            <FormattedMessage id='Navigation.Cert_All' />
          </Link>
          <span className='text-4xl' role='img' aria-label='Scroll'>
            📜
          </span>
        </p>
        <p className={linkStyles}>
          <Link to='/account'>
            <FormattedMessage id='Navigation.Account' />
          </Link>
          <span className='text-4xl' role='img' aria-label='Hammer and Wrench'>
            🛠️
          </span>
        </p>
      </div>
    </div>
  );
};

export default WelcomeCard;
